import { call, put, takeEvery } from 'redux-saga/effects'
import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'
import { renderErrorNotification } from '../../helpers/apiHelpers'

export function* loadAutoIntegrateHistory(action) {
  try {
    yield put({ type: 'SET_LOADING' })
    yield put({ type: 'UNSET_LOADING_ERROR' })

    api.setAuthApi({ 'Authorization': sessionHelpers.getApplicationCookie('authentication_token') })

    const id = action.payload.id
    const request = { url: `/shop_orders/${id}/ai_activity_items` }
    const response = yield call(api.utility.get, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'SHOP_ORDER_AI_HISTORY_LOAD_SUCCEEDED',
      payload: { data: response.body }
    })

    yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    yield put(renderErrorNotification(`Error fetching data: ${apiErrorHelpers.toString(errors)}`))

    apiErrorHelpers.consoleLog(errors)
  }
} // loadAutoIntegrateHistory()

export default function* versionSaga() {
  yield takeEvery('SHOP_ORDER_AI_HISTORY_LOAD_SAGA', loadAutoIntegrateHistory)
}
